import React, { useState } from 'react';
import SEO from '../components/SEO';
import Header from '../components/Header';
import ModelSelector from '../components/ModelSelector';
import NumberDisplay from '../components/NumberDisplay';
import SavedNumbers from '../components/SavedNumbers';
import AdBanner from '../components/AdBanner';
import { generateNumbers } from '../services/api';
import './LottoPage.css';

function LottoPage() {
  const [generatedData, setGeneratedData] = useState(null);
  const [savedRefresh, setSavedRefresh] = useState(0);

  const handleGenerate = async (model, options) => {
    try {
      const response = await generateNumbers(model, options);
      if (response.success) {
        setGeneratedData(response.data);
        // Scroll to results
        setTimeout(() => {
          const element = document.querySelector('.number-display');
          if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }, 100);
      }
    } catch (error) {
      throw error;
    }
  };

  const handleSave = () => {
    setSavedRefresh(prev => prev + 1);
  };

  return (
    <div className="lotto-page">
      <SEO
        title="AI 로또 번호 추천 - 인공지능 로또번호 생성 & 예측"
        description="AI 로또 번호 추천! 인공지능 7가지 모델로 오늘의 로또 번호를 추천받으세요. AI 로또 예측, 패턴 분석, 통계 기반 GPT 로또 번호 추천을 무료로 제공합니다."
        keywords="AI 로또 번호 추천, AI 추천 로또 번호, AI 로또번호, 인공지능 로또 번호 추천, 인공지능 로또, AI 로또 예측, AI 로또 분석, AI 로또번호 생성, GPT 로또 번호, 챗GPT 로또, 오늘 로또 번호 추천, 로또운세, 로또번호생성, 로또통계, 로또패턴"
        url="https://lottounse.kr/lotto"
      />
      <Header />

      <AdBanner />

      <main className="main-content">
        <ModelSelector onGenerate={handleGenerate} />

        {generatedData && (
          <>
            <AdBanner />
            <NumberDisplay
              generatedData={generatedData}
              onSave={handleSave}
            />
          </>
        )}

        <AdBanner />

        <SavedNumbers key={savedRefresh} />
      </main>
    </div>
  );
}

export default LottoPage;
